import {
  React,
  Component
} from 'imports/CommonImports';

import {
  Paper,
} from 'material-ui';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    backgroundColor: '#FBFBFB',
    padding: '2em',
  },
  header: {
    marginBottom: '0',
  },
}

class NoPostulatedProjects extends Component {

  render() {
    return (
      <Paper zDepth={1} style={styles.container}>
        <h3 style={styles.header}>¡Lo sentimos!</h3>
        <p style={styles.p}>{this.props.message}</p>
        {this.props.button ? this.props.button : null}
      </Paper>
    );
  }
}

export default NoPostulatedProjects;



// WEBPACK FOOTER //
// ./src/components/postulation/NoPostulatedProjects.js